module.exports = __webpack_public_path__ + "static/media/stijn-bessem-portfolio-digital-mountain-front-1440x400.5d01391d.png";